import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { EditorChangeContent } from "ngx-quill";
import { Routes } from "src/app/models/routes";
import Quill from "quill";
import { SmsService } from "src/app/services/sms.service";
import { SnackbarService } from "src/app/services/snackbar.service";

@Component({
  selector: "app-create-sms",
  templateUrl: "./create-sms.component.html",
  styleUrls: ["./create-sms.component.css"],
})
export class CreateSmsComponent implements OnInit {
  smsForm: FormGroup;
  submitted: boolean = false;
  // toolbarOptions = [
  //   ["bold", "italic", "underline"],
  //   [{ list: "ordered" }, { list: "bullet" }],
  //   [{ align: [] }],
  //   ["link"],
  // ];
  editor: any;

  routes: Routes = new Routes();

  constructor(
    private _fb: FormBuilder,
    private _smsService: SmsService,
    private _router: Router,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.smsForm = this._fb.group({
      description: ["", Validators.required],
    });

    if (this._smsService.checkedCategoryList == undefined) {

      const getIds = localStorage.getItem("selectedSmsUsers");
      this._smsService.checkedCategoryList = JSON.parse(getIds);
    }
    console.log("isASelectAll", this._smsService.isSelectedAll);
  }

  get f() {
    return this.smsForm.controls;
  }

  created(quill: Quill) {
    console.log("Editor created:", quill);
    this.editor = quill;
  }

  // onContentChanged(event: any) {
  //   const fullText = event.editor.getText().trim();

  //    if (fullText !== this.smsForm.value.description) {
  //     this.smsForm.patchValue({ description: fullText }, { emitEvent: false });
  //   }
  // }

  removeHtmlTags(text: string): string {
    return text.replace(/<[^>]*>/g, "").trim();
  }
  createBlog() {
    this.submitted = true;
    if (this.smsForm.valid) {
      console.log(
        "success of mass mobile numbers removed validation of client feedback"
      );
      // const plaintext = this.editor?.getText().trim();
      // console.log("this", this.editor.getText())
      const payload: any = {
        content: this.smsForm.value.description,
      };
      if (this._smsService.isSelectedAll) {
        payload.isSelectAll = true;
      } else {
        payload._id = this._smsService.checkedCategoryList;
      }

      this._smsService.SendSms(payload).subscribe((response: any) => {
        if (response.status == 200) {
          this.smsForm.reset();
          this.submitted = false;
          this._router.navigate(["/send-sms"]);
          this.snackbarService.showSuccess(
            response.message || "Sms sent successfully!"
          );
          localStorage.removeItem("selectedSmsPage");
          localStorage.removeItem("selectedSmsUsers");
          this._smsService.checkedCategoryList = [];
        }
      });
    } else{
      this.snackbarService.alert("Description is required");
    }
  }
}
